import { filter } from "lodash";
import authentication from "@irati/auth";
import { UpsellRegion } from "@irati/types";
import Products from "../enums/Products";
import ProductTrackingNames from "../enums/ProductTrackingNames";
import shouldShowUpSaleScreens from "./shouldShowUpSaleScreens";
export function shouldShowHomepage() {
    var isMedicalActive = !!authentication.apps("medical");
    var activeProducts = getActiveProducts();
    var hasCultureHub = !!authentication.apps("platform.cultureHub.read");
    var hasHomepageTiles = !!authentication.apps("platform.homepageTiles.read");
    return activeProducts.length > 1 || isMedicalActive || shouldShowUpSaleScreens() || hasCultureHub || hasHomepageTiles;
}
export function getActiveProducts() {
    return filter(productList(), function (product) { return product.active; });
}
export function getInactiveProducts() {
    var productsNotActive = filter(productList(), function (product) { return !product.active; });
    var products = productsNotActive.map(function (product) {
        switch (product.product) {
            case Products.medical:
                return authentication.upsell().region === UpsellRegion.Gbr ? product : null;
            default:
                return product;
        }
    });
    return filter(products, function (product) { return !!product; });
}
function productList() {
    var _a = authentication.apps(), perks = _a.perks, recognition = _a.recognition, medical = _a.medical, insights = _a.insights;
    return [
        {
            product: Products.perks,
            active: !!perks,
            trackingName: ProductTrackingNames.perks
        },
        {
            product: Products.recognition,
            active: !!recognition,
            trackingName: ProductTrackingNames.recognition
        },
        {
            product: Products.medical,
            active: !!medical,
            trackingName: ProductTrackingNames.medical
        },
        {
            product: Products.insights,
            active: !!insights,
            trackingName: ProductTrackingNames.insights
        }
    ];
}
